import { wGroupIndicesATGeometry } from 'components/AgentTemplateEditView/menu/geometry';
import { IColumn } from 'components/general/types';
import { ISurfaceMaterial } from 'components/general/types/spacecraft';
import WidgetTable from 'components/general/widgets/WidgetTable';
import EntityTableSegment from 'components/general/wizards/EntityTableSegment';
import useStyles from 'components/general/wizards/WizardSegment/styles';
import { useActiveEntities, useEntityDialogControl } from 'hooks';
import { SurfaceVables, TSurfaceTypesKeys } from 'utils/vable';
import ExternalSurfacesDialog from './ExternalSurfaceDialog';
import SurfaceMaterialDialog from './SurfaceMaterialDialog';

const guidance = {
  heading: 'Create and External Surfaces and Surface Materials',
  body: [
    {
      chunk: 'Surfaces are fundamental to building up a physical model of your satellite.',
    },
    {
      subHeading: 'Links to Modeling',
      chunk:
        'Surfaces are used as the mounting location for solar panels and used to compute atmospheric drag, radiative heat transfer, and solar radiation pressure perturbations.',
    },
  ],
};

const materialColumns = [
  {
    title: 'Part Number',
    field: 'partNumber',
  },
];

const SurfaceMaterialSegment = () => {
  const { classes } = useStyles();
  const { surfaceMaterials } = useActiveEntities();
  const materialEntityDialogControl = useEntityDialogControl<ISurfaceMaterial>();

  return (
    <>
      <div>
        <h6 style={{ paddingLeft: 8 }}>Surface Materials</h6>
        <WidgetTable
          className={classes.table}
          columns={materialColumns}
          data={surfaceMaterials}
          modelName="surface material"
          onFabClick={materialEntityDialogControl.openDialogForNew}
          onActionClick={materialEntityDialogControl.openDialogForExisting}
        />
      </div>
      <SurfaceMaterialDialog control={materialEntityDialogControl} />
    </>
  );
};

const columns: IColumn[] = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Type',
    field: 'type',
    render: (rowData) => SurfaceVables.Type[rowData.type as TSurfaceTypesKeys].label,
  },
  {
    title: 'Vector',
    render: (rowData) => rowData.bodyFrameVector?.name || 'undefined',
  },
];

const ExternalSurfacesSegment = () => {
  const { surfaces } = useActiveEntities();

  return (
    <EntityTableSegment
      title="External Surfaces"
      index={wGroupIndicesATGeometry.SURFACES}
      guidance={guidance}
      entityColumns={columns}
      entityData={surfaces}
      DialogComponent={ExternalSurfacesDialog}
      modelName="external surface"
      suffix={<SurfaceMaterialSegment />}
    />
  );
};

export default ExternalSurfacesSegment;
